import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import routes from 'app/routes';

import {
  Link,
} from 'react-router-dom';

export default function SelectedTime({
  step, fullSelectedDay, monthTimeSlots, selectedTime,
}) {
  return (
    <div className="d-flex justify-content-between gap-3 mt-4 align-items-center">
      <div className="time-zone">
        {fullSelectedDay && !selectedTime
          && moment.parseZone(fullSelectedDay).format('MMMM D, YYYY')}
        {selectedTime && moment.parseZone(selectedTime).format('MMMM D, YYYY [at] hh:mm A')}
        {!fullSelectedDay && !selectedTime && (
        <span className="text-danger">Please select a date and a time slot</span>
        )}
        {' '}
        {monthTimeSlots?.timezone}
      </div>

      <div style={{ minWidth: '150px' }}>

        <Link className="btn btn-primary btn-sm" to={routes.members.steps.timezone(step.id)}>
          Set My Timezone
        </Link>
      </div>
    </div>
  );
}

SelectedTime.propTypes = {
  step: PropTypes.object.isRequired,
  fullSelectedDay: PropTypes.instanceOf(Date),
  monthTimeSlots: PropTypes.object.isRequired,
  selectedTime: PropTypes.instanceOf(Date),
};

SelectedTime.defaultProps = {
  fullSelectedDay: null,
  selectedTime: null,
};
